import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminCreateUser = () => {
  const queryClient = useQueryClient();

  return apiClient.admin.createUser.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-users-list'] });
      toast.success('User created successfully!');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error creating user!');
    },
  });
};
